<div class="app-details" *ngIf="!isLoading">
  <div class="row">
    <div class="col-lg-8 col-md-12">
      <mat-card>
        <mat-card-content>
          <h4 style="color: #313131" class="mb-4">
            <strong>Application Detail</strong>
            <hr />
          </h4>
          <div class="d-flex justify-content-center">
            <mat-chip-list>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">tag</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Application Number:</span>
                  <span>{{ applicationDetails?.apn }} </span>
                </div>
              </mat-chip>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">person</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Full Name:</span>
                  <span
                    >{{ applicantDetails.firstName }}
                    {{ applicantDetails.lastName }}</span
                  >
                </div>
              </mat-chip>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">mail</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Email Address:</span>
                  <span> {{ applicantDetails.email }}</span>
                </div>
              </mat-chip>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">call</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Contact Number:</span>
                  <span>{{ applicantDetails.contactNumber }}</span>
                </div>
              </mat-chip>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">work</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Occupation:</span
                  ><span style="margin-left: 5px">
                    {{
                      getOccupation(
                        applicationDetails.workingPermitType,
                        applicationDetails.occupation
                      )
                    }}

                  </span>
                </div>
              </mat-chip>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">location_city</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Establishment:</span>
                  <span>{{ applicationDetails.occupationEstablishment }}</span>
                </div>
              </mat-chip>
              <mat-chip class="chip mx-1">
                <mat-icon class="me-3 text-success">location_city</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">Establishment Address:</span>
                  <span>{{
                    applicationDetails.occupationEstablishmentAddress
                  }}</span>
                </div>
              </mat-chip>
              <mat-chip
                class="chip mx-1"
                style="background-color: #54bb8b36"
                (click)="openMoreInfo()"
              >
                <mat-icon class="me-3 text-success">add</mat-icon>
                <div class="d-flex flex-column">
                  <span class="text-muted">More info</span>
                </div>
              </mat-chip>
            </mat-chip-list>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-4 col-md-12">
      <mat-card style="background-color: #54bb8b36">
        <mat-card-content>
          <div class="icon">
            <mat-icon>assignment</mat-icon>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <h6 style="color: #198754">Permit Type:</h6>
              <h4>
                <strong style="color: #198754">
                  {{ getPermitType(applicationDetails.workingPermitType) }}
                </strong>
              </h4>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-content>
          <div class="icon">
            <mat-icon>calendar_month</mat-icon>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <h6>Date Submitted:</h6>
              <h4>
                <strong
                  >{{ applicationDetails.createdDate | date : "mediumDate" }}
                </strong>
              </h4>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="applicationDetails.chsoDoctorStatus == 3">
        <mat-card-content>
          <div class="row">
            <div class="col-lg-12">
              <h6>Application QR Code:</h6>
              <qrcode
                [qrdata]="applicationQrCode"
                [width]="150"
                [errorCorrectionLevel]="'M'"
              ></qrcode>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <mat-card>
        <mat-card-content>
          <div class="row">
            <div class="col-lg-6">
              <div>
                <h4 style="color: #313131" class="mb-4">
                  <strong>Application Status</strong>
                  <hr />
                </h4>
                <h4>
                  <strong
                    [ngStyle]="{
                      color:
                        applicationDetails.applicationStatusDisplayName ===
                        'For Compliance'
                          ? 'red'
                          : '#198754'
                    }"
                  >
                    <span
                      style="font-weight: bold"
                      [ngClass]="{
                        'status-PE':
                          applicationDetails.applicationStatusDisplayName ===
                          'Parallel Evaluation',
                        'status-FPE':
                          applicationDetails.applicationStatusDisplayName ===
                          'For PESO Evaluation',
                        'status-FS':
                          applicationDetails.applicationStatusDisplayName ===
                          'For Signature',
                        'status-FR':
                          applicationDetails.applicationStatusDisplayName ===
                          'For Releasing',
                        'status-inc':
                          applicationDetails.applicationStatusDisplayName ===
                          'Incomplete',
                        'status-Released':
                          applicationDetails.applicationStatusDisplayName ===
                          'Released'
                      }"
                    >
                      {{ applicationDetails.applicationStatusDisplayName }}
                    </span>
                  </strong>
                </h4>
              </div>

              <div style="border-radius: 20px; padding: 10px">
                <ng-container>
                  <small>
                    <span class="fw-bold">
                      Health Services Office:
                      <span class="fst-italic">
                        {{ getCHSOStatus() }}
                        <ng-container
                          *ngIf="applicationDetails.applicationStatus !== 9"
                        >
                          {{
                            applicationDetails.chsoLabStatus === 0
                              ? "(Pending Requirements)"
                              : applicationDetails.chsoDoctorStatus === 0 ||
                                applicationDetails.chsoDoctorStatus === 4
                              ? "(For Doctors Evaluation)"
                              : applicationDetails.chsoSanStatus === 0 &&
                                applicationDetails.workingPermitType !== 3 &&
                                applicationDetails.workingPermitType !== 4
                              ? "(For Sanitation Processing)"
                              : ""
                          }}</ng-container
                        >
                      </span>
                    </span>
                  </small>
                  <div class="d-flex flex-column">
                    <small class="fst-italic">
                      Laboratory:
                      {{
                        applicationDetails.chsoLabStatus == 3
                          ? "Compliant"
                          : applicationDetails.chsoLabStatus == 2
                          ? "Non-Compliant"
                          : "Pending"
                      }}
                    </small>
                    <small class="fst-italic">
                      Doctor:
                      {{ applicationDetails.chsoDoctorStatusName }}
                    </small>
                    <small
                      class="fst-italic"
                      *ngIf="
                        applicationDetails.workingPermitType !== 3 &&
                        applicationDetails.workingPermitType !== 4
                      "
                    >
                      Sanitation:
                      {{
                        applicationDetails.chsoSanStatus == 3
                          ? "Compliant"
                          : applicationDetails.chsoSanStatus == 2
                          ? "Non-Compliant"
                          : "Pending"
                      }}
                    </small>
                  </div>
                  <br />
                  <small>
                    <span class="fw-bold">
                      Baguio City Police Office:
                      <span class="fst-italic">
                        {{
                          applicationDetails.bcpoStatus == 3
                            ? "Compliant"
                            : applicationDetails.bcpoStatus == 2
                            ? "Non-Compliant"
                            : applicationDetails.bcpoStatus == 4
                            ? "For Processing"
                            : "Pending"
                        }}
                      </span>
                    </span>
                  </small>
                </ng-container>
              </div>
              <!-- <h6
                (click)="openListOfRequirements()"
                class="hover-pointer"
                style="text-decoration: underline; color: blue"
              >
                List of Requirements
              </h6> -->
            </div>
            <!-- <div class="col-lg-6">
              <div
                class="d-flex justify-content-center align-items-center h-100"
                style="
                  background-color: wheat;
                  border-radius: 20px;
                  padding: 10px;
                "
              >
                <div class="d-flex flex-column">
                  <small class="fw-bold">Applicant's Notification:</small>
                  <small [innerHTML]="safeHtmlContent"></small>
                </div>
              </div>
            </div> -->
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="app-timeline">
    <mat-card>
      <mat-card-content>
        <h4 style="color: #313131" class="mb-4">
          <strong>Application Timeline</strong>
          <hr />
        </h4>
        <div>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            class="mb-2"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                ><mat-icon
                  aria-hidden="false"
                  class="mr-2"
                  style="color: #198754"
                  >timeline</mat-icon
                >
                View Timeline</mat-panel-title
              >
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-md-12">
                <app-application-timeline
                  [timeline]="groupedTimelineData"
                ></app-application-timeline>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="app-timeline">
    <mat-card>
      <mat-card-content>
        <h4 style="color: #313131" class="mb-4">
          <strong>Receipts</strong>
          <hr />
        </h4>
        <div>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            class="mb-2"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                ><mat-icon
                  aria-hidden="false"
                  class="mr-2"
                  style="color: #198754"
                  >receipt</mat-icon
                >
                View Receipts</mat-panel-title
              >
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-md-12">
                <table
                  mat-table
                  [dataSource]="dataSourceBreakDownFees"
                  class="mat-elevation-z8"
                  [style.width.%]="100"
                  style="border-radius: 4px; box-shadow: none"
                >
                  <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

                  Position Column
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef [hidden]="true">
                      test
                    </th>
                    <td mat-cell *matCellDef="let element" [hidden]="true">
                      {{ element.id }}
                    </td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="ReceiptNo">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="background: #198754; color: #ffffff"
                      class="text-center"
                    >
                      No
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      {{ element.receiptNumber }}
                    </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="receiptType">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="background: #198754; color: #ffffff"
                      class="text-center"
                    >
                      Receipt Type
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      {{ element.receiptTypeName }}
                    </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="Date Issued">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="background: #198754; color: #ffffff"
                      class="text-center"
                    >
                      Date
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      {{ element.dateIssued | date : "longDate" }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="Amount">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      style="background: #198754; color: #ffffff"
                      class="text-center"
                    >
                      Amount
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      PHP {{ element.amountPaid }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsBreakDownFees"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsBreakDownFees"
                  ></tr>
                </table>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="app-timeline" *ngIf="applicationDetails.workingPermitType == 1">
    <mat-card>
      <mat-card-content>
        <h4 style="color: #313131" class="mb-4">
          <strong>Seminar</strong>
          <hr />
        </h4>
        <div>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            class="mb-2"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                ><mat-icon
                  aria-hidden="false"
                  class="mr-2"
                  style="color: #198754"
                  >event_note</mat-icon
                >
                Food Handler Seminar</mat-panel-title
              >
            </mat-expansion-panel-header>
            <div>
              <p>
                <span class="fw-bold">Seminar Date:</span>
                {{
                  applicationDetails.seminarSchedules[0]?.seminarDateName | date
                }}
              </p>
              <p>
                <span class="fw-bold"> Time Slot: </span>
                {{
                  applicationDetails.seminarSchedules[0]?.timeslot.timeslotName
                }}
              </p>
              <p>
                <span class="fw-bold"> Attendance: </span>
                {{
                  applicationDetails.seminarSchedules[0]?.isAttended
                    ? "Attended"
                    : "Not Attended"
                }}
              </p>
              <div class="d-flex justify-content-between">
                <div></div>
                <button
                  class="my-3"
                  mat-raised-button
                  color="primary"
                  style="color: white"
                  (click)="handleAttendance()"
                  [disabled]="
                    applicationDetails.seminarSchedules[0]?.isAttended ||
                    evaluatorRole !== 'CHSO-SAN'
                  "
                >
                  Mark as Attended
                </button>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="app-forms">
    <mat-card>
      <mat-card-content>
        <div class="d-flex justify-content-between my-3">
          <div>
            <button
              *ngIf="
                (evaluatorRole == 'CHSO-DOC' ||
                  evaluatorRole == 'CHSO-LAB' ||
                  evaluatorRole == 'CHSO-SAN') &&
                applicationDetails.workingPermitType !== 3 &&
                applicationDetails.workingPermitType !== 4
              "
              mat-raised-button
              color="primary"
              style="color: white"
              (click)="handleRequireSyphilis()"
              [disabled]="hasSyphilis"
            >
              Require Syphilis Test
            </button>
          </div>
          <div
            *ngIf="
              evaluatorRole == 'CHSO-DOC' &&
              applicationDetails.chsoDoctorStatus !== 3
            "
          >
            <button
              mat-raised-button
              class="text-orange"
              (click)="handleForObservation()"
              [disabled]="
                applicationDetails.chsoDoctorStatus == 4 ||
                applicationDetails.chsoDoctorStatus == 2 ||
                isDocumentsCleared() ||
                !isDocumentsEvaluated()
              "
            >
              For Observation
            </button>
          </div>
        </div>
        <mat-tab-group>
          <mat-tab *ngIf="evaluatorRole == 'BCPO-R'">
            <ng-template mat-tab-label>
              <mat-icon aria-hidden="false" class="mr-2" style="color: #198754"
                >account_box</mat-icon
              >
              Information
            </ng-template>
            <div>
              <div class="row mt-3">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Distinguishing marks</mat-label>
                  <textarea
                    matInput
                    [(ngModel)]="applicationDetails.distinguishingMarkDesc"
                    maxlength="250"
                    disabled
                    [style.height.px]="100"
                    style="color: black !important"
                  ></textarea>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Crime</mat-label>
                  <input
                    matInput
                    [(ngModel)]="applicationDetails.crimeChargedWith"
                    disabled
                    style="color: black !important"
                  />
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Case Disposition</mat-label>
                  <input
                    matInput
                    [(ngModel)]="applicationDetails.caseDisposition"
                    disabled
                    style="color: black !important"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-tab>
          <mat-tab *ngIf="evaluatorRole !== 'BCPO-R'">
            <div class="my-2" *ngIf="evaluatorRole == 'CHSO-LAB'">
              <button
                mat-raised-button
                color="primary"
                class="text-white"
                (click)="handleLabUpload()"
                [disabled]="
                  applicationDetails.chsoLabStatus == 3 ||
                  applicationDetails.workingPermitType == 3 ||
                  applicantDetails.workingPermitType == 4
                "
              >
                Upload Lab Result
              </button>
            </div>
            <ng-template mat-tab-label>
              <mat-icon aria-hidden="false" class="mr-2" style="color: #198754"
                >content_paste</mat-icon
              >
              Laboratory Results
            </ng-template>
            <div>
              <p
                class="text-center"
                *ngIf="
                  applicationDetails.workingPermitType == 3 ||
                  applicationDetails.workingPermitType == 4
                "
              >
                Please refer to submitted lab results.
              </p>

              <table
                *ngIf="
                  applicationDetails.workingPermitType !== 3 &&
                  applicationDetails.workingPermitType !== 4
                "
                mat-table
                [dataSource]="applicationDocuments"
                [style.width.%]="100"
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Document</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="document">
                      {{
                        element.resultTypeValue == 1
                          ? "Stool Lab Results"
                          : element.resultTypeValue == 2
                          ? "X-ray Lab Results"
                          : element.resultTypeValue == 3
                          ? "Syphilis Lab Results"
                          : ""
                      }} </span
                    ><br />
                    <span
                      *ngIf="
                        element.resultTypeValue == 2 &&
                        applicationDetails.applicationXRayDiagnoses.length !== 0
                      "
                    >
                      ({{
                        applicationDetails.applicationXRayDiagnoses[
                          applicationDetails.applicationXRayDiagnoses.length - 1
                        ].xRayDiagnosisName
                      }})</span
                    >
                  </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.uploadedDate | date : "longDate" }}
                    {{ element.uploadedDate | date : "shortTime" }}
                  </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element">
                    <span
                      class="status"
                      [ngClass]="{
                        'status-approved': element.status == 1,
                        'status-rejected': element.status == 2,
                        'status-pending':
                          element.status !== 1 && element.status !== 2
                      }"
                    >
                      {{
                        element.status == 1
                          ? "Compliant"
                          : element.status == 2
                          ? "Not Compliant"
                          : "Pending"
                      }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remarks">
                  <th mat-header-cell *matHeaderCellDef>Remarks</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-button (click)="viewRemarks(element)">
                      <mat-icon
                        [matBadgeColor]="
                          element.remarks.length !== 0 ? 'warn' : 'accent'
                        "
                        [matBadge]="element.remarks.length"
                        matBadgeOverlap="false"
                        >visibility</mat-icon
                      >
                    </button>
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-button [matMenuTriggerFor]="menu">
                      Select <mat-icon> arrow_drop_down </mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <ng-container *ngIf="element.fileDetails.length !== 0">
                        <button
                          mat-menu-item
                          (click)="openLightBox(element.fileDetails)"
                          *ngIf="isImage(element.fileDetails[0]?.fullPath)"
                        >
                          View
                        </button>
                        <button
                          [disabled]="element.status == 3"
                          mat-menu-item
                          *ngIf="!isImage(element.fileDetails[0]?.fullPath)"
                        >
                          <a
                            [href]="element.fileDetails[0]?.fullPath"
                            target="_blank"
                          >
                            View
                          </a>
                        </button>
                      </ng-container>
                      <button mat-menu-item (click)="onViewDetails(element)">
                        View Details
                      </button>
                      <button mat-menu-item (click)="onViewHistory(element)">
                        View File History
                      </button>

                      <button
                        *ngIf="evaluatorRole == 'CHSO-DOC'"
                        mat-menu-item
                        (click)="onEvaluate(element)"
                      >
                        Evaluate
                      </button>
                      <button
                        *ngIf="evaluatorRole == 'CHSO-LAB'"
                        mat-menu-item
                        (click)="onUpload(element)"
                      >
                        Upload Result
                      </button>
                      <button
                        *ngIf="element.resultTypeValue == 2"
                        mat-menu-item
                        (click)="onUpload(element)"
                      >
                        <a
                          href="../../../../assets/documents/xray-form.pdf"
                          target="_blank"
                        >
                          Print X-ray Result
                        </a>
                      </button>
                      <button
                        *ngIf="element.resultTypeValue == 1"
                        mat-menu-item
                        (click)="onUpload(element)"
                      >
                        <a
                          href="../../../../assets/documents/stool-results.pdf"
                          target="_blank"
                        >
                          Print Stool Result
                        </a>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon aria-hidden="false" class="mr-2" style="color: #198754"
                >assignment</mat-icon
              >
              Documents
            </ng-template>
            <div>
              <table
                mat-table
                [dataSource]="supportingFiles"
                [style.width.%]="100"
              >
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Document</th>
                  <td mat-cell *matCellDef="let element">
                    <span class="document">{{ element.fileDescription }} </span>
                  </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      element.createdDate | date : "longDate" : "Asia/Manila"
                    }}
                    {{
                      element.createdDate | date : "shortTime" : "Asia/Manila"
                    }}
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-button [matMenuTriggerFor]="menu">
                      Select <mat-icon> arrow_drop_down </mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a mat-menu-item (click)="viewPdf(element)">View</a>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="supportingFilesColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: supportingFilesColumns"
                ></tr>
              </table>
            </div>
            <div class="d-flex flex-column">
              <button
                *ngIf="!hasWorkingPermit && evaluatorRole == 'CHSO-SAN'"
                class="mt-5 mb-2"
                mat-raised-button
                color="primary"
                style="color: white"
                (click)="upload(0)"
                [disabled]="
                  applicationDetails.applicationStatus !== 25 ||
                  evaluatorRole !== 'CHSO-SAN'
                "
              >
                Generate Working Permit
              </button>
              <button
                *ngIf="!hasHealthCard && evaluatorRole == 'CHSO-SAN'"
                class="my-2"
                mat-raised-button
                color="primary"
                style="color: white"
                (click)="upload(this.applicationDetails.workingPermitType)"
                [disabled]="
                  applicationDetails.applicationStatus !== 25 ||
                  evaluatorRole !== 'CHSO-SAN'
                "
              >
                Generate Health Card
              </button>
              <ng-container *ngIf="evaluatorRole == 'CHSO-DOC'">
                <button
                  *ngIf="
                    !hasPinkCard && applicationDetails.workingPermitType === 3
                  "
                  class="my-2"
                  mat-raised-button
                  color="primary"
                  style="color: white"
                  (click)="upload(applicationDetails.workingPermitType)"
                >
                  Generate Pink Card
                </button>

                <button
                  *ngIf="
                    !hasBlueCard && applicationDetails.workingPermitType === 4
                  "
                  class="my-2"
                  mat-raised-button
                  color="primary"
                  style="color: white"
                  (click)="upload(applicationDetails.workingPermitType)"
                >
                  Generate Blue Card
                </button>

                <button
                  *ngIf="
                    !hasWorkingPermit &&
                    (applicationDetails.workingPermitType === 3 ||
                      applicationDetails.workingPermitType === 4)
                  "
                  class="my-2"
                  mat-raised-button
                  color="primary"
                  style="color: white"
                  (click)="upload(0)"
                  [disabled]="applicationDetails.applicationStatus !== 25"
                >
                  Generate Working Permit
                </button>
              </ng-container>
              <button
                *ngIf="
                  applicationDetails.workingPermitType == 1 &&
                  !hasSeminarCert &&
                  evaluatorRole == 'CHSO-SAN'
                "
                class="my-2"
                mat-raised-button
                color="primary"
                style="color: white"
                (click)="upload(-1)"
                [disabled]="
                  applicationDetails.applicationStatus !== 25 ||
                  evaluatorRole !== 'CHSO-SAN'
                "
              >
                Generate Food Handler Seminar Ceritificate
              </button>
              <button
                *ngIf="
                  !hasNsrpForm &&
                  evaluatorRole == 'PESO-R' &&
                  applicationDetails.applicationStatus == 27
                "
                class="my-2"
                mat-raised-button
                color="primary"
                style="color: white"
                (click)="upload(5)"
              >
                Generate NSRP Form
              </button>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon aria-hidden="false" class="mr-2" style="color: #198754"
                >checklist</mat-icon
              >
              Remarks
            </ng-template>
            <div>
              <app-general-remarks
                [details]="applicationDetails"
              ></app-general-remarks>
            </div>
          </mat-tab>
        </mat-tab-group>

        <hr
          style="
            border: none;
            border-top: 1px solid #a3a3a3;
            margin: 60px 0px 40px 0px;
          "
        />
        <div class="seminar-container" *ngIf="showSeminarContainer">
          <div *ngIf="showDatePicker" class="progress-line"></div>

          <div class="seminar" [formGroup]="seminarForm">
            <strong>Attended the seminar?</strong>
            <div>
              <mat-radio-group
                formControlName="attendedSeminar"
                (change)="onSeminarAttendanceChange()"
              >
                <mat-radio-button value="true" style="padding: 5px"
                  >Yes</mat-radio-button
                >
                <mat-radio-button value="false" style="padding: 5px"
                  >No</mat-radio-button
                >
              </mat-radio-group>
            </div>

            <div
              *ngIf="showDatePicker"
              style="margin-top: 5px; font-size: 1rem"
            >
              <label style="padding: 5px">Seminar Date:</label>
              <mat-form-field
                appearance="outline"
                style="width: 150px; margin-top: 0px"
              >
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="seminarDate"
                  placeholder="Select date"
                  style="font-size: 0.875em; margin-bottom: 2px"
                  [max]="maxDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div
          class="mt-3"
          *ngIf="
            applicationDetails.seminarScheduleDate &&
            applicationDetails.seminarScheduleDate !== '' &&
            evaluatorRole === 'CHSO-DOC'
          "
        >
          <strong>Seminar Date Attended:</strong>
          <span>
            {{ applicationDetails.seminarScheduleDate | date : "MM/dd/yyyy" }}
          </span>
          <br />
          <strong>Expiration Date:</strong>
          <span>
            {{ expirationDate | date : "MM/dd/yyyy" }}
          </span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="px-3 mb-5">
    <ng-container
      *ngIf="
        applicationDetails.applicationStatus == 25 &&
        evaluatorRole == 'CHSO-DOC' &&
        (applicationDetails.chsoDoctorStatus == 0 ||
          applicationDetails.chsoDoctorStatus == 4)
      "
    >
      <div class="d-flex justify-content-between">
        <button
          mat-raised-button
          color="accent"
          [disabled]="!hasLaboratoriesNotCleared()"
          (click)="handleEvaluatorReturn()"
        >
          Unfit for Work
        </button>

        <button
          mat-raised-button
          color="primary"
          style="color: white"
          (click)="approve()"
          [disabled]="
            isLoading ||
            !hasLaboratoriesCleared() ||
            (applicationDetails.workingPermitType === 3 &&
              (!hasPinkCard || !hasWorkingPermit)) ||
            (applicationDetails.workingPermitType === 4 &&
              (!hasBlueCard || !hasWorkingPermit))
          "
        >
          {{ isLoading ? "Submitting" : "Fit to Work" }}
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="applicationDetails.applicationStatus == 10">
      <div class="d-flex justify-content-between">
        <div></div>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="approve()"
          [disabled]="!hasHealthCard && !hasWorkingPermit"
        >
          Forward to BCPO
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        applicationDetails.applicationStatus == 25 &&
        evaluatorRole == 'BCPO-R' &&
        applicationDetails.bcpoStatus !== 3
      "
    >
      <div class="d-flex justify-content-between">
        <div>
          <button
            mat-raised-button
            color="accent"
            (click)="handleEvaluatorReturn()"
            *ngIf="
              applicationDetails.bcpoStatus == 0 ||
              applicationDetails.bcpoStatus == 1
            "
          >
            Notify Applicant
          </button>
        </div>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="forBcpoProcessing()"
          *ngIf="applicationDetails.bcpoStatus !== 4"
          [disabled]="isLoading"
        >
          {{ isLoading ? "Submitting" : "For Processing" }}
        </button>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="forBcpoApprove()"
          *ngIf="applicationDetails.bcpoStatus == 4"
        >
          Forward
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        applicationDetails.applicationStatus == 25 &&
        evaluatorRole == 'CHSO-SAN' &&
        applicationDetails.chsoSanStatus == 0
      "
    >
      <div class="d-flex justify-content-between">
        <div>
          <button
            mat-raised-button
            color="accent"
            [disabled]="!hasLaboratoriesNotCleared()"
            (click)="handleEvaluatorReturn()"
          >
            Return to Applicant
          </button>
        </div>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="approve()"
          [disabled]="!hasWorkingPermit || !hasHealthCard"
        >
          Forward
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        applicationDetails.applicationStatus == 25 &&
        evaluatorRole == 'CHSO-LAB' &&
        applicationDetails.chsoLabStatus == 0
      "
    >
      <div class="d-flex justify-content-between">
        <div></div>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="approve()"
        >
          Forward
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        applicationDetails.applicationStatus == 21 &&
        evaluatorRole == 'PESO-R' &&
        applicationDetails.pesoStatus == 0
      "
    >
      <div class="d-flex justify-content-between">
        <div></div>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="pesoApprove()"
          [disabled]="
            !hasWorkingPermit ||
            (applicationDetails.workingPermitType === 3
              ? !hasPinkCard
              : applicationDetails.workingPermitType === 4
              ? !hasBlueCard
              : !hasHealthCard) ||
            isLoading
          "
        >
          {{ isLoading ? "Submitting" : "Approve" }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="applicationDetails.applicationStatus == 26">
      <div class="d-flex justify-content-between">
        <div></div>
        <button
          *ngIf="evaluatorRole == 'CMO-R'"
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="cmoApprove()"
          [disabled]="
            !hasWorkingPermit ||
            (applicationDetails.workingPermitType === 3
              ? !hasPinkCard
              : applicationDetails.workingPermitType === 4
              ? !hasBlueCard
              : !hasHealthCard) ||
            isLoading
          "
        >
          {{ isLoading ? "Submitting" : "For Releasing" }}
        </button>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        applicationDetails.applicationStatus == 27 && evaluatorRole == 'PESO-R'
      "
    >
      <div class="d-flex justify-content-between">
        <div></div>
        <button
          style="color: white"
          mat-raised-button
          color="primary"
          (click)="pesoRelease()"
          [disabled]="
            !hasNsrpForm ||
            !hasWorkingPermit ||
            (applicationDetails.workingPermitType === 3
              ? !hasPinkCard
              : applicationDetails.workingPermitType === 4
              ? !hasBlueCard
              : !hasHealthCard) ||
            isLoading
          "
        >
          {{ isLoading ? "Submitting" : "Release Working Permit" }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
<div class="spinner" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
